<button 
    mat-mini-fab 
    class="admin-theme" 
    matBadgeSize="large" 
    [matBadge]="numberOfUnsavedChanges()" 
    [matBadgeHidden]="!unsavedChanges()" 
    [disabled]="!unsavedChanges()"
    (click)="save()">
    <mat-icon>save</mat-icon>
</button>